import jQuery from "jquery";
import 'devbridge-autocomplete';
import infoImage from '../images/info.svg';
import infoImageHover from '../images/info-hover.svg';

document.addEventListener('DOMContentLoaded', () => {
    function showNotificationWhenCheckboxIsClicked() {
        const isLoggedIn = document.querySelector('.logged-in');
        if (!isLoggedIn) return;

        const checkbox = document.querySelector('#ship-to-same-address-checkbox');
        const label = document.querySelector('#ship-to-same-address label');
        const span = label.querySelector('span');

        if (!span) {
            console.error('Span not found inside the label.');
            return;
        }

        // Create a wrapper div
        const wrapperDiv = document.createElement('div');
        wrapperDiv.classList.add('wrapper-div');

        // Wrap the span with the wrapper div
        span.parentNode.insertBefore(wrapperDiv, span);
        wrapperDiv.appendChild(span);

        // Show notification when checkbox is checked
        checkbox.addEventListener('change', () => {
            if (checkbox.checked) {
                const newParagraph = document.createElement('p');
                newParagraph.textContent = 'Controleer je factuurgegevens voordat je een bestelling plaatst.';
                newParagraph.id = 'ship-to-same-address__notification'; // Add an ID for easy reference
                wrapperDiv.appendChild(newParagraph);

                return;
            }

            const existingParagraph = document.getElementById('ship-to-same-address__notification');
            if (existingParagraph) {
                existingParagraph.remove();
            }
        });
    }

    showNotificationWhenCheckboxIsClicked();

    let openModal = null;
    let openImg = null;

    function onHoverImg() {
        document.querySelectorAll('.form-row').forEach(row => {
            const hotspot = row.querySelector('.billing-tooltip');
            const img     = row.querySelector('.billing-tooltip img');
            const input   = row.querySelector('.woocommerce-input-wrapper');
            const modal   = row.querySelector('.billing-tooltip__modal');

            if (!hotspot || !img || !input || !modal) return;

            hotspot.addEventListener('mouseover', () => {
                if (openModal && openModal !== modal) {
                    openModal.style.display = 'none';
                    if (openImg) openImg.src = infoImage;
                    openModal = null;
                    openImg   = null;
                }

                img.src = infoImageHover;
            });

            hotspot.addEventListener('mouseout', () => {
                if (openModal !== modal) img.src = infoImage;
            });

            input.addEventListener('mousedown', e => {
                e.stopPropagation();

                if (openModal && openModal !== modal) {
                    openModal.style.display = 'none';
                    if (openImg) openImg.src = infoImage;
                }

                modal.style.display = 'flex';
                img.src   = infoImageHover;
                openModal = modal;
                openImg   = img;
            });
        });

        document.addEventListener('click', e => {
            if (openModal && !openModal.contains(e.target)) {
                openModal.style.display = 'none';
                if (openImg) openImg.src = infoImage;
                openModal = null;
                openImg   = null;
            }
        });
    }



    function addTooltip(fieldId = null) {
        const tooltipText = document.getElementById('tooltip_checkout_page')?.value;
        const isLoggedIn = document.querySelector('.logged-in');
        if (!isLoggedIn || !tooltipText) return;

        const fields = fieldId
            ? [document.querySelector(`#${fieldId}`)]
            : document.querySelectorAll('.woocommerce-billing-fields__field-wrapper .form-row');

        fields.forEach((field) => {
            if (!field) return;

            const label = field.querySelector('label');
            const input = field.querySelector('input, select, textarea'); // Check for input elements

            if (!label || !input || (input.tagName === 'SELECT' ? false : !input.readOnly)) {
                return;
            }

            if (field.querySelector('.billing-tooltip')) {
                return;
            }

            // Create tooltip elements
            const wrapperDiv = document.createElement('div');
            const span = document.createElement('span');
            const img = document.createElement('img');
            const modal = document.createElement('div');

            wrapperDiv.classList.add('label-wrapper');
            span.classList.add('billing-tooltip');
            modal.classList.add('billing-tooltip__modal');
            modal.innerHTML = tooltipText;
            img.src = infoImage;
            img.alt = 'Info';

            // Build the tooltip structure
            span.appendChild(img);
            span.appendChild(modal);

            // Wrap the label and add tooltip
            label.parentNode.insertBefore(wrapperDiv, label);
            wrapperDiv.appendChild(label);
            wrapperDiv.appendChild(span);
        });
    }

    addTooltip();
    addTooltip('coc_number_field');
    addTooltip('billing_country_field');
    onHoverImg();

    (function ($) {

        let dataMap = {};

        // Check whichever checkbox is checked. Uncheck the other one.
        const sameAddressCheckbox = document.getElementById('ship-to-same-address-checkbox');
        const differentAddressCheckbox = document.getElementById('ship-to-different-address-checkbox');
        const shippingAddress = document.querySelector('.shipping_address');

        sameAddressCheckbox?.addEventListener('change', function () {
            if (this.checked) {
                differentAddressCheckbox.checked = false;
                shippingAddress.style.display = 'none';
            }
        });

        differentAddressCheckbox?.addEventListener('change', function () {
            if (this.checked) {
                sameAddressCheckbox.checked = false;
                shippingAddress.style.display = '';
            }
        });

        $('.billing-company-ac input:not([readonly])').each(function () {
            var company = $(this);
            company.closest('.form-row').addClass('autocomplete')
                .append('<span class="form-loader"></span>');
            var ac = company.attr('autocomplete');
            window.setTimeout(function () {
                company.attr('autocomplete', ac);
            }, 10);

            company.devbridgeAutocomplete({
                serviceUrl: localCheckout.ajax_url +
                    '?action=' + localCheckout.action +
                    '&key=' + localCheckout.nonce,

                dataType: 'json',
                paramName: 'q',
                ajaxSettings: {
                    beforeSend: function () {
                        company.closest('.form-row').addClass('is-loading');
                        company.closest('.woocommerce-input-wrapper').addClass('coc-loader')
                    },
                    success: function () {
                        company.closest('.form-row').removeClass('is-loading');
                        company.closest('.woocommerce-input-wrapper').removeClass('coc-loader');
                    },
                    error: function () {
                        company.closest('.form-row').removeClass('is-loading');
                        company.closest('.woocommerce-input-wrapper').removeClass('coc-loader');
                    }
                },

                transformResult: function (response) {
                    return {
                        suggestions: $.map(response, function (item) {
                            return {value: item.handelsnaam, data: item.kvkNummer};
                        })
                    };
                },

                minChars: 2,
                triggerSelectOnValidInput: false,
                autoSelectFirst: true,
                deferRequestBy: 500,

                onSelect: function (suggestion) {
                    company.closest('.form-row').addClass('is-loading');
                    company.closest('.woocommerce-input-wrapper').addClass('coc-loader');
                    $.getJSON(localCheckout.ajax_url + '?kvkNummer=' + suggestion.data + '&action=' + localCheckout.complete_action + '&key=' + localCheckout.complete_nonce, function (data) {
                        company.closest('.form-row').removeClass('is-loading');
                        company.closest('.woocommerce-input-wrapper').removeClass('coc-loader');
                        updateFrom(company, data);
                    });
                },

                onHide: function () {
                }
            });
        });


        function updateFrom(src, item) {
            if (item) {
                // Add this class to show street field after autocomplete
                $('body').addClass('manual-address');

                var form = src.closest('form');

                form.find('a[href="#addr-manual"]').trigger('click');

                form.find('[name=\'coc_number\']').val(item.kvkNummer);

                let completeHouseNumber = item.adres.huisletter !== undefined ? item.adres.huisnummer + item.adres.huisletter : item.adres.huisnummer
                completeHouseNumber = isNaN(completeHouseNumber) ? '' : completeHouseNumber

                if (item.adres) {
                    form.find('#billing_address_1').val([
                        item.adres.straatnaam,
                        item.adres.huisnummer,
                        item.adres.huisletter
                    ].join(' '));
                    form.find('#billing_address_1_street').val(item.adres.straatnaam)
                    form.find('#billing_address_1_housenr').val(completeHouseNumber);
                    form.find('#billing_housenr').val(completeHouseNumber);
                    form.find('#billing_postcode').val(item.adres.postcode);
                    form.find('#billing_postcode_clone').val(item.adres.postcode);
                    form.find('#billing_city').val(item.adres.plaats);
                }
                // form.find('#billing_country').val('NL')
                //     .trigger('change');
                form.find('#website').val(item.website);
            }
        }

    })(jQuery);
});
